import { createApp } from 'vue';
import JpgToIcoConverter from '../Components/JpgToIcoConverter.vue';

const root = document.getElementById('jpg-to-ico-converter');
if (root) {
  createApp(JpgToIcoConverter).mount('#jpg-to-ico-converter');
}
